var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 404,
    viewBox: "0 0 404 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800293 0.296875H404V403.497H0.800293V0.296875Z",
    fill: "#41558D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.652 104.098C217.776 103.359 243.316 106.805 268.271 114.436C275.675 116.722 282.883 119.504 289.893 122.78C290.016 160.705 290.032 198.631 289.945 236.555C287.094 244.917 283.141 252.684 278.085 259.856C272.456 267.818 266.072 275.183 258.93 281.95C247.52 292.548 235.205 301.924 221.985 310.078C214.6 314.708 206.956 318.923 199.052 322.726C179.568 313.269 161.638 301.532 145.26 287.512C137.628 280.859 130.648 273.6 124.321 265.734C119.039 259.041 114.596 251.799 110.992 244.007C109.929 241.519 108.949 239 108.053 236.45C107.982 198.595 107.982 160.741 108.053 122.885C113.12 120.43 118.316 118.279 123.639 116.43C141.554 110.307 159.958 106.458 178.847 104.885C183.129 104.58 187.398 104.317 191.652 104.098Z",
    fill: "#D4ECA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242 141H165V168H242V141Z",
    fill: "#7A97CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 195V272H194.333V222.133H242V195H165Z",
    fill: "#7A97CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.b67b9316fb85ded3ae12463324c6ee35.svg";
export { ForwardRef as ReactComponent };